import client from "services/ngage/api-client";
import {FactTemplate, FactTemplateData} from "types/FactTemplate";
import DataPage from "types/DataPage";
import deserializeFactTemplate from "services/ngage/deserializers/fact-template";

/**
 * Get all fact templates (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<FactTemplate> | null>(`/fact-templates?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeFactTemplate)
    }

    return response.data
}

/**
 * Get a single fact template
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<FactTemplate>(`/fact-templates/${id}`)
    return response.data? deserializeFactTemplate(response.data) : null
}

/**
 * Store a new fact template
 *
 * @param data
 */
const store = async (data: FactTemplateData) => {
    const response = await client.post<FactTemplate>('/fact-templates', data)
    return response.data? deserializeFactTemplate(response.data) : null
}

/**
 * Update an existing fact template
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: FactTemplateData) => {
    const response = await client.put<FactTemplate>(`/fact-templates/${id}`, data)
    return response.data? deserializeFactTemplate(response.data) : null
}

/**
 * Permanently delete a fact template
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/fact-templates/${id}`)
    return response.status === 204
}

const factTemplates = {
    all,
    get,
    store,
    update,
    destroy
}

export default factTemplates;